/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role, jsx-a11y/anchor-is-valid */

import React from 'react';
import { Badge, ListGroup, Table } from 'react-bootstrap';

import delay from '../../../modules/delay';
import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import PageHeader from '../../atoms/PageHeader';
import SearchInput from '../../components/SearchInput';
import TablePagination from '../../components/TablePagination';
import EmptyTableAlert from '../../components/EmptyTableAlert';
import LinkContainer from '../../containers/LinkContainer';

import Styles from './styles';

class AdminUsers extends React.Component {
  state = {
    total: 0,
    users: [],
    usersPerPage: 10,
    currentPage: 1,
    searching: false
  };

  componentDidMount() {
    this.fetchUsers();
  }

  fetchUsers = async search => {
    const { currentPage, usersPerPage } = this.state;
    try {
      const { total, users } = await methodPromise('admin.fetchUsers', {
        currentPage,
        perPage: usersPerPage,
        search
      });
      this.setState({ total, users });
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  changePage = pageNumber => this.setState({ currentPage: pageNumber }, () => this.fetchUsers());

  handleSearch = event => {
    event.persist();
    if (event.target.value.trim() !== '') {
      this.setState({ searching: true });
      delay(() => this.fetchUsers(event.target.value.trim()), 500);
    } else {
      this.setState({ searching: false });
      this.fetchUsers();
    }
  };

  render() {
    const { total, users, searching, usersPerPage, currentPage } = this.state;
    return (
      <>
        <PageHeader>
          <h4>Users {total && <Badge variant="secondary">{total}</Badge>}</h4>
          <div className="ml-auto">
            <SearchInput placeholder="Search users..." onKeyUp={this.handleSearch} />
          </div>
        </PageHeader>
        {users.length > 0 ? (
          <ListGroup className="mx-0">
            {users.map(({ _id, emails, username, profile, service }) => (
              <LinkContainer key={_id} to={`/admin/users/${_id}`}>
                <ListGroup.Item action>
                  {profile ? `${profile.name.first} ${profile.name.last}` : username}{' '}
                  <span className="px-2 text-muted">{emails[0].address}</span>{' '}
                  {service !== 'password' && (
                    <Styles.ServiceBadge service={service}>{service}</Styles.ServiceBadge>
                  )}
                </ListGroup.Item>
              </LinkContainer>
            ))}
          </ListGroup>
        ) : (
          <Table responsive hover size="sm">
            <EmptyTableAlert numberOfColumns={1} message="No Users yet!" />
          </Table>
        )}
        <TablePagination
          totalCount={total}
          itemsPerPage={usersPerPage}
          currentPage={currentPage}
          changePage={this.changePage}
          isPaginationOn={!!total && !searching}
        />
      </>
    );
  }
}

AdminUsers.propTypes = {};

export default AdminUsers;
